import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

import Sidebar from './components/Sidebar/Sidebar';
import Navbar from './components/Navbar/Navbar';
import Dashboard from './components/Dashboard/Dashboard';
import ProvidersList from './components/Providers/ProvidersList';
import ProviderDetails from './components/Providers/ProviderDetails';
import CreateProvider from './components/Providers/CreateProvider';
import EditProvider from './components/Providers/EditProvider';
import ProviderApproval from './components/Providers/ProviderApproval';
import BookingsList from './components/Bookings/BookingsList';
import BookingDetails from './components/Bookings/BookingDetails';
import CreateBooking from './components/Bookings/CreateBooking';
import CustomersList from './components/Customers/CustomersList';
import CustomerDetails from './components/Customers/CustomerDetails';
import CreateCustomer from './components/Customers/CreateCustomer';
import EditCustomer from './components/Customers/EditCustomer';
import PaymentsList from './components/Payments/PaymentsList';
import PayoutsList from './components/Payouts/PayoutsList';
import DisputesList from './components/Disputes/DisputesList';
import DisputeDetails from './components/Disputes/DisputeDetails';
import PromotionsList from './components/Promotions/PromotionsList';
import CreatePromotion from './components/Promotions/CreatePromotion';
import EditPromotion from './components/Promotions/EditPromotion';
import ServicesList from './components/Services/ServicesList';
import CreateService from './components/Services/CreateService';
import EditService from './components/Services/EditService';
import ServiceDetails from './components/Services/ServiceDetails';
import Analytics from './components/Analytics/Analytics';
import Settings from './components/Settings/Settings';
import AuditLog from './components/AuditLog/AuditLog';
import ContentManagement from './components/ContentManagement/ContentManagement';
import LoyaltyManagement from './components/Loyalty/LoyaltyManagement';
import WalletManagement from './components/Wallet/WalletManagement';
import TicketsList from './components/Support/TicketsList';
import TicketDetails from './components/Support/TicketDetails';
import Login from './components/Auth/Login';
import ForgotPassword from './components/Auth/ForgotPassword';
import VerifyOtp from './components/Auth/VerifyOtp';
import ResetPassword from './components/Auth/ResetPassword';
import Refunds from './components/Refunds/Refunds';
import ChatHistory from './components/ChatHistory/ChatHistory';
import SpamReports from './components/SpamReports/SpamReports';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('isAuthenticated');
    setIsAuthenticated(false);
  };

  if (!isAuthenticated) {
    return (
      <Router>
        <Routes>
          <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/verify-otp" element={<VerifyOtp />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
    );
  }

  return (
    <Router>
      <div className="app-container">
        <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} logout={logout} />
        <Navbar toggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} logout={logout} />
        <div className={`main-content ${sidebarOpen ? '' : 'sidebar-closed'}`}>
          <Routes>
            {/* Dashboard */}
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />

            {/* Providers */}
            <Route path="/providers" element={<ProvidersList />} />
            <Route path="/providers/:id" element={<ProviderDetails />} />
            <Route path="/providers/create" element={<CreateProvider />} />
            <Route path="/providers/:id/edit" element={<EditProvider />} />
            <Route path="/providers/approval" element={<ProviderApproval />} />

            {/* Bookings */}
            <Route path="/bookings" element={<BookingsList />} />
            <Route path="/bookings/:id" element={<BookingDetails />} />
            <Route path="/bookings/create" element={<CreateBooking />} />

            {/* Customers */}
            <Route path="/customers" element={<CustomersList />} />
            <Route path="/customers/:id" element={<CustomerDetails />} />
            <Route path="/customers/create" element={<CreateCustomer />} />
            <Route path="/customers/:id/edit" element={<EditCustomer />} />

            {/* Payments & Payouts */}
            <Route path="/payments" element={<PaymentsList />} />
            <Route path="/payouts" element={<PayoutsList />} />
            <Route path="/refunds" element={<Refunds />} />

            {/* Disputes */}
            <Route path="/disputes" element={<DisputesList />} />
            <Route path="/disputes/:id" element={<DisputeDetails />} />

            {/* Promotions */}
            <Route path="/promotions" element={<PromotionsList />} />
            <Route path="/promotions/create" element={<CreatePromotion />} />
            <Route path="/promotions/:id/edit" element={<EditPromotion />} />

            {/* Services */}
            <Route path="/services" element={<ServicesList />} />
            <Route path="/services/create" element={<CreateService />} />
            <Route path="/services/:id" element={<ServiceDetails />} />
            <Route path="/services/:id/edit" element={<EditService />} />

            {/* Analytics */}
            <Route path="/analytics" element={<Analytics />} />

            {/* Settings */}
            <Route path="/settings" element={<Settings />} />

            {/* Audit Log */}
            <Route path="/audit-log" element={<AuditLog />} />

            {/* Content Management */}
            <Route path="/content" element={<ContentManagement />} />

            {/* Loyalty Management */}
            <Route path="/loyalty" element={<LoyaltyManagement />} />

            {/* Wallet Management */}
            <Route path="/wallet" element={<WalletManagement />} />

            {/* Chat History */}
            <Route path="/chat-history" element={<ChatHistory />} />

            {/* Spam Reports */}
            <Route path="/spam-reports" element={<SpamReports />} />

            {/* Support Tickets */}
            <Route path="/support/tickets" element={<TicketsList />} />
            <Route path="/support/tickets/:id" element={<TicketDetails />} />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/dashboard" />} />
          </Routes>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </Router>
  );
}

export default App;